import { render } from "./ConfirmMetadata.vue?vue&type=template&id=b82cccea&scoped=true&ts=true"
import script from "./ConfirmMetadata.vue?vue&type=script&lang=ts"
export * from "./ConfirmMetadata.vue?vue&type=script&lang=ts"

import "./ConfirmMetadata.vue?vue&type=style&index=0&id=b82cccea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82cccea"]])

export default __exports__